import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/developer-activity.png";
import Toolstack from "./Toolstack";
import { useTranslation } from 'react-i18next';
import "./About.css";

function About() {
  const { t } = useTranslation();

  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
            {t('about')} <strong className="mainColor">{t('me')}</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "0px", paddingBottom: "50px" }}
            className="about-img"
          >
            <img src={laptopImg} alt="about" className="img-fluid theme-img" />
          </Col>
        </Row>
        <h1 className="project-heading">
          <strong className="mainColor">{t('skills')} </strong>
        </h1>

        <Techstack />

        <h1 className="project-heading">
          <strong className="mainColor">{t('tools')}</strong>
        </h1>
        <Toolstack />

      </Container>
    </Container>
  );
}

export default About;
